import Layout from '../views/layout/Layout'

export default {
  path: '/system',
  component: Layout,
  redirect: 'noredirect',
  name: 'system',
  meta: {
    title: '系统管理',
    elicon: 'el-icon-fa-cog',
    roles: ['system.user.list'],
  },
  children: [
    {
      path: 'profile',
      name: 'system.profile',
      component: () => import('@/views/system/profile'),
      meta: {
        title: '个人信息', // 个人信息页面默认已登录即可访问
        roles: ['default'],
      },
    },
    {
      path: 'users',
      name: 'system.users',
      component: () => import('@/views/system/users'),
      meta: {
        title: '账号管理',
        roles: ['system.user.list'],
      },
    },
    {
      path: 'adx-white-list',
      name: 'system.adx-white-list',
      component: () => import('@/views/system/adx-white-list'),
      meta: {
        title: 'adx 报警白名单',
        roles: ['monitor.mid-whitelist.list'],
      },
    },
    {
      path: 'quick-layout-list',
      name: 'system.quick-layout-list',
      component: () => import('@/views/system/quick-layout'),
      meta: {
        title: 'ps快捷布局脚本',
        roles: ['system.user.list'],
      },
    },
    {
      path: 'file-upload',
      name: 'system.file-upload',
      component: () => import('@/views/system/file-upload'),
      meta: {
        title: '文件上传',
        roles: ['system.user.list'],
      },
    },
    {
      path: 'async-component-config',
      name: 'system.async-component-config',
      component: () => import('@/views/system/async-component-config'),
      meta: {
        title: '组件配置同步',
        roles: ['system.user.list'],
      },
    },
  ],
}
